import React from 'react';
import PropTypes from 'prop-types';

import { useGameStatus } from '../hooks/store';
import { useDictionary, useMediaConfig } from '../hooks/config';
import { GAME_STATUS, GAME_ROUTE } from '../utils/constants';

import { DateUtils } from 'bdvp-common/src/utils';

const MoreFromThisGameTag = (props) => {

    const {
        gamePk,
        defaultUrl,
        onClick,
        render,
    } = props;

    const dictionary = useDictionary();
    const { gameRecapMinYear = 2016 } = useMediaConfig();
    const { data = {} } = useGameStatus(gamePk);

    return render({
        url: (
            data.games?.[0]?.status === GAME_STATUS.final
            && DateUtils.getYear(DateUtils.date(data.games?.[0]?.gameDate)) >= gameRecapMinYear
        )
            ? { pathname: `${GAME_ROUTE}/${gamePk}` }
            : defaultUrl,
        displayName: dictionary.more_from_this_game ?? 'More From This Game',
        onClick,
    });

};

MoreFromThisGameTag.propTypes = {
    gamePk: PropTypes.number.isRequired,
    defaultUrl: PropTypes.shape({
        pathname: PropTypes.string.isRequired,
        search: PropTypes.string,
    }).isRequired,
    render: PropTypes.func.isRequired,
    onClick: PropTypes.func,
};

MoreFromThisGameTag.defaultProps = {
    onClick: () => {},
};

export default MoreFromThisGameTag;
